import { useEffect } from "react";

export default function CursorTracer() {
  useEffect(() => {
    // Skip on touch devices
    if (typeof window === "undefined") return;

    const inner = document.getElementById("cursor-inner");
    const outer = document.getElementById("cursor-outer");
    if (!inner || !outer) return;

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let ox = x;
    let oy = y;
    let raf = 0;
    let visible = false;

    const show = () => {
      if (visible) return;
      visible = true;
      inner.style.opacity = "1";
      outer.style.opacity = "1";
    };
    const hide = () => {
      visible = false;
      inner.style.opacity = "0";
      outer.style.opacity = "0";
    };

    // Start hidden until first move so the tracer doesn't flash center on load
    inner.style.opacity = "0";
    outer.style.opacity = "0";

    const onMove = (e) => {
      x = e.clientX;
      y = e.clientY;
      show();
    };

    const onOver = (e) => {
      const el = e.target;
      if (!(el instanceof Element)) return;
      if (el.closest('a, button, [role="button"], input, textarea, select, label, [data-cursor-hover]')) {
        document.body.classList.add("cursor-hover");
      } else {
        document.body.classList.remove("cursor-hover");
      }
    };

    const tick = () => {
      ox += (x - ox) * 0.18;
      oy += (y - oy) * 0.18;
      inner.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
      outer.style.transform = `translate3d(${ox}px, ${oy}px, 0) translate(-50%, -50%)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });
    window.addEventListener("mouseleave", hide);
    window.addEventListener("blur", hide);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      window.removeEventListener("mouseleave", hide);
      window.removeEventListener("blur", hide);
      document.body.classList.remove("cursor-hover");
    };
  }, []);

  return (
    <>
      <div id="cursor-outer" className="cursor-tracer-outer" aria-hidden="true" data-testid="cursor-tracer-outer" />
      <div id="cursor-inner" className="cursor-tracer-inner" aria-hidden="true" data-testid="cursor-tracer-inner" />
    </>
  );
}
